export var LOGIN_ROUTE_NAME;
(function (LOGIN_ROUTE_NAME) {
    LOGIN_ROUTE_NAME["MAIN_LOGIN"] = "mainLogin";
    LOGIN_ROUTE_NAME["EUREKA_LOGIN"] = "eurekaLogin";
    LOGIN_ROUTE_NAME["SUB_LOGIN"] = "subLogin";
})(LOGIN_ROUTE_NAME || (LOGIN_ROUTE_NAME = {}));
